import { useCallback, useEffect, useState } from 'react';

interface ICaptionsHook {
  captionsEnabled: boolean;
  toggleCaptions: () => void;
}

export default function useCaptions(
  videoRef: React.RefObject<HTMLVideoElement | null>,
  subtitlesURL?: string
): ICaptionsHook {
  const [captionsEnabled, setCaptionsEnabled] = useState(false);

  // Sync track mode with state
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !subtitlesURL) return;

    const tracks = video.textTracks;
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].mode = captionsEnabled ? 'showing' : 'hidden';
    }
  }, [captionsEnabled, videoRef, subtitlesURL]);

  const toggleCaptions = useCallback(() => {
    if (!subtitlesURL) return;
    setCaptionsEnabled((prev) => !prev);
  }, [subtitlesURL]);

  return { captionsEnabled, toggleCaptions };
}
